(function () {
  const content = `
    <h4><strong>Contre-indications</strong></h4>
    <p>Ce dispositif est contre-indiqué chez toute personne pour qui la compression pourrait être délétère, c'est-à-dire en cas de :</p>
    <ul>
      <li>artériopathie oblitérante des membres inférieurs (AOMI) avec un index de pression systolique (IPS) &lt; 0.6</li>
      <li>microangiopathie diabétique évoluée (pour les bas délivrant une pression &gt; 30 mmHg)</li>
      <li>Phlegmatia coerulea dolens (phlébite bleue douloureuse avec compression artérielle)</li>
      <li>thrombose septique</li>
      <li>insuffisance cardiaque décompensée</li>
      <li>intolérance ou allergie aux matériaux composant le dispositif (soie, tencel)</li>
    </ul>
    <p><strong>Allergie à la soie : Extrêmement rares !</strong> Cependant, certaines personnes peuvent réagir aux produits chimiques utilisés lors de la transformation de la soie. C'est pourquoi il est important de choisir une soie certifiée ŒKO-TEX®. Notre fibre de soie est certifiée ŒKO-Tex Step®.</p>
    <p>Allergie possible à l'élasthanne mais il n'est jamais en contact direct avec la peau avec nos produits deuxième peau®.</p>
  `;

  const overlay = document.createElement('div');
  overlay.id = 'ci-modal-overlay';
  overlay.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:9999;align-items:center;justify-content:center;';

  const modal = document.createElement('div');
  modal.style.cssText = 'background:#fff;max-width:600px;width:90%;max-height:80vh;overflow-y:auto;padding:2rem;position:relative;border-radius:4px;font-size:1rem;line-height:1.6;color:#121212;';


  const closeBtn = document.createElement('button');
  closeBtn.innerHTML = '&times;';
  closeBtn.style.cssText = 'position:absolute;top:1rem;right:1rem;background:none;border:none;font-size:1.5rem;cursor:pointer;line-height:1;';

  modal.innerHTML = content;
  const style = document.createElement('style');
style.textContent = `
  #ci-modal-overlay ul {
    list-style: disc;
    padding-left: 1.5rem;
    margin: 1rem 0;
  }
  #ci-modal-overlay li {
    margin-bottom: 0.5rem;
  }
  #ci-modal-overlay p {
    margin-bottom: 1rem;
  }
  #ci-modal-overlay h4 {
    margin-bottom: 1rem;
    font-size: 1.1rem;
  }
`;
document.head.appendChild(style);

  modal.prepend(closeBtn);
  overlay.appendChild(modal);
  document.body.appendChild(overlay);

  function openModal() {
    overlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    overlay.style.display = 'none';
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  document.addEventListener('click', function (e) {
    const link = e.target.closest('a');
    if (link && link.href && link.href.includes('/pages/contre-indications')) {
      e.preventDefault();
      openModal();
    }
  });
})();
